import queries from '@apis/queries';
import { GetNotificationsParams, NotificationRow } from '@models/notification';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';

import { notificationsAtom } from '../atoms/notificationAtoms';

function useNotifications() {
  const [notifications, setNotifications] = useAtom(notificationsAtom);
  const [page, setPage] = useState<number>(0);
  const params: GetNotificationsParams = {
    page, size: 20,
  };
  const { data, status } = useQuery(queries.notifications.list(params));
  const isLoading = status === 'pending';
  const isBlank = (!isLoading) && notifications.length === 0;
  useEffect(() => {
    if (data) {
      if (page === 0) {
        setNotifications(data.content);
      } else {
        setNotifications((prev) => [...prev, ...data.content]);
      }
    }
  }, [data]);
  const fetchNext = () => {
    if (status === 'success' && data && !data.slice.last) {
      setPage((prev) => prev + 1);
    }
  };

  return {
    notifications,
    fetchNext,
    isLoading,
    isBlank,
  };
}

export default useNotifications;
